G.WorldMapAppearFlow = G.WorldMapAppearFlow || {};

G.WorldMapAppearFlow.payloadChecker = (function () {
  // imports
  var saveStateMgr = null;
  var currentPlayerId = null;
  var gatesMgr = null;
  var levelDataMgr = null;
  var SendableResourceType = null;

  var payloadChecked = false;

  var onPopUpReqested = new Phaser.Signal();
  var onOpenGate = new Phaser.Signal();

  return {
    onPopUpReqested: onPopUpReqested,
    checkPayloadAtPreloader: checkPayloadAtPreloader,
    checkPayloadAtWorld: checkPayloadAtWorld,
    onOpenGate: onOpenGate,
    cleanup: cleanup,
    getMsgId: getMsgId
  };

  /**
   * Checks the payload at PRELOADER
   * @param {Object} payload
   */
  function checkPayloadAtPreloader(payload) {
    saveStateMgr = G.saveState;
    currentPlayerId = OMT.envData.settings.user.userId;
    if (payload.friendshipChestInvite) {
      checkfriendshipChestInvitePayload(payload, payload.friendshipChestInvite, true);
    }

    if (payload.fortuneCookie && G.firstTime) {
      checkFortuneCookiePayload(payload, payload.fortuneCookie);
    }
  }

  /**
   * Checks the payload at WORLD
   * @param {Object} payload
   */
  function checkPayloadAtWorld(payload) {
    if(payloadChecked) return;

    // handle imports
    saveStateMgr = G.saveState;
    gatesMgr = G.Helpers.gatesMgr;
    levelDataMgr = G.Helpers.levelDataMgr;
    SendableResourceType = G.HighscorePanel2Data.SendableResourceType;

    if (payload.inGameMsg === 'Invite') {
      checkInvitePayload();
    }

    if (payload.command) {
      checkCommandPayload(payload, payload.command);
    }

    if (payload.gift) {

      if (payload.additions && payload.additions.quiz) {
        checkQuizPayload(payload, payload.gift, payload.additions.quiz.correctAnswer);
      } else if (!(payload.additions && payload.additions.restoreProgression)) {
        checkGiftPayload(payload, payload.gift);
      }
    }

    if (payload.life) {
      checkLifePayload(payload, payload.life);
    }
    
    if (payload.lifeRequest) {
      checkLifeRequestPayload(payload, payload.lifeRequest);
    }

    if (payload.gate) {
      checkGatePayload(payload, payload.gate);
    }

    if (payload.gateRequest) {
      checkGateRequestPayload(payload, payload.gateRequest);
    }

    if (payload.thanks) {
      checkThanksPayload(payload, payload.thanks);
    }

    if (payload.additions && payload.additions.restoreProgression) {
      checkRestoreProgressionPayload(payload, payload.additions.restoreProgression);
    }

    if (payload.promoReward) {
      checkPromoRewardPayload(payload);
    }

    if (payload.requestHelp) {
      checkRequestHelpPayload(payload, payload.requestHelp);
    }

    if (payload.friendshipChestInvite) {
      checkfriendshipChestInvitePayload(payload, payload.friendshipChestInvite, false);
    }

    if (payload.friendshipChestJoin) {
      checkfriendshipChestJoinPayload(payload, payload.friendshipChestJoin);
    }
    if (payload.stateChange) {
      checkStateChangePayload(payload, payload.stateChange);
    }

    if (payload.fortuneCookie) {
      checkFortuneCookiePayload(payload, payload.fortuneCookie);
    }

    // track bot message on game-backend
    if (OMT.bots.entryPointIsBotMsg) OMT.bots.trackBotConversion();

    payloadChecked = true;

  }


  /**
   * get the message id. we check a couple places for backwards compatibility
   * @param {Object} payload 
   * @returns {string}
   */
  function getMsgId(payload) {

    let msgId = null;
    if (payload.sendParams && payload.sendParams.msgID) {
      msgId = payload.sendParams.msgID;
    } else { // recursively check for id value
      for (let i in payload) {
        if (i === 'id') return payload[i];
        if (typeof payload[i] === 'object') {
          msgId = getMsgId(payload[i])
          if (msgId) break;
        }
      }
    }
    return msgId;
  }

  /**
   * reformat gift data object array to the ['booster#1',1] style format used in the game
   * @param {Object} giftData 
   * @returns {Array}
   */
  function reformatGiftData(giftData) {

    let gameGiftDataList = [];
    try {
      const giftDataList = Array.isArray(giftData) ? giftData : [giftData];
      giftDataList.forEach((giftData) => {
        gameGiftDataList.push([giftData.itemId, giftData.amount]);
      });
    } catch(e) {
      G.Utils.SentryLog.logError('No gift data attached to gift payload!',{})
      gameGiftDataList = G.gift.getGift('normals'); 
    }
    return gameGiftDataList;
  }

  function checkInvitePayload() {
    // does nothing yet except tracking 
    OMT.platformTracking.logEvent(OMT.platformTracking.Events.InviteFromReferral);
  }

  function checkCommandPayload(payload, command) {
    if (command.goToLevel) {
      if (levelDataMgr.getLevelByIndex(command.goToLevel.levelIndex)) {
        onPopUpReqested.dispatch(['level', command.goToLevel.levelIndex]);
      }
    }
  }

  function checkGiftPayload(payload, giftPayload) {

    const giftDataList = reformatGiftData(giftPayload.giftData);
    const msgId = getMsgId(payload);
    const payLoadOK = !G.saveState.isMsgRead(msgId) && giftPayload.sender !== currentPlayerId;

    if (payLoadOK) {

      onPopUpReqested.dispatch(['gift', {
        showTitleBar: false,
        showGingy: false,
        showGingyGiftBar: false,
        autoOpen: true,
        autoOpenDelay: 1500,
        gifts: giftDataList,
        onClaim: function(){
          G.saveState.markMsgAsRead('payloadGifts' , msgId);
        },
        monetiseType: false,
        resourceTracking: {
          itemType: 'Reward',
          itemId: 'PayloadGift',
        },
        shareable: false,
        ddnaEventData: {transactionType:'REWARD', tActionType:'BOT', tGameArea:'MAP'}
      }], false, G.WindowMgr.LayerNames.Base);
    }
  }

  function checkLifePayload(payload, lifePayload) {
    let msgId = getMsgId(payload);
    if (!saveStateMgr.isMsgRead(msgId)
      && lifePayload.sender !== currentPlayerId) {
      onPopUpReqested.dispatch('lifeReceived');
      saveStateMgr.markMsgAsRead('acceptedLives', msgId);
    }
  }

  function checkLifeRequestPayload(payload, lifeRequestPayload) {

    let msgId = getMsgId(payload);

    if (!saveStateMgr.isMsgRead(msgId)
      && lifeRequestPayload !== currentPlayerId) {

        OMT.social.sendLifeMessage(lifeRequestPayload.sender, (success) => {
          if (!success) {
            onPopUpReqested.dispatch('lifeSentSuccessfully');
            saveStateMgr.markMsgAsRead('acceptedLivesRequests', msgId);
            saveStateMgr.setResourceSentTimestamp(
              lifeRequestPayload.sender,
              SendableResourceType.LifeShare
            );
            saveStateMgr.save();
          }
        }); 
    }
  }

  function checkGatePayload(payload, gatePayload) {
    /*
    if (gatePayload.sender !== currentPlayerId
      && gatePayload.forPlayer === currentPlayerId) {
      var result = gatesMgr.addGateInvite(
        gatePayload.gateId,
        gatePayload.sender,
        gatePayload.senderAvatar,
      );
      if (result.inviteAccepted) {
        gatesMgr.unlockGate(gatePayload.gateId);
      }
    }
    */
   // Doesn't do anything because GBC will do the unlocking ;)
  }

  async function checkGateRequestPayload(payload, gateRequestPayload) {
    let msgId = getMsgId(payload);
    if (!saveStateMgr.isMsgRead(msgId)
    && gateRequestPayload.sender !== currentPlayerId) {
      let result = await OMT.social.sendGateMsg(gateRequestPayload.sender, gateRequestPayload.gateId);
      if (result) {
        OMT.messaging.sendMessage(gateRequestPayload.gbUserId, "gateHereKey", {messageType:"gateHereKey", gateId: gateRequestPayload.gateId, sender: gateRequestPayload.sender, senderAvatar: gateRequestPayload.senderAvatar});
        saveStateMgr.markMsgAsRead('acceptedGateRequests', msgId);
        onPopUpReqested.dispatch(['thanksForHelp', gateRequestPayload]);
      }
    }
  }

  function checkThanksPayload(payload, thanksPayload) {
    let msgId = getMsgId(payload, thanksPayload);
    if (!saveStateMgr.isMsgRead(msgId)
      && thanksPayload.sender !== currentPlayerId) {
      saveStateMgr.markMsgAsRead('thanksMsg', msgId);
      onPopUpReqested.dispatch(['thanksForHelp', thanksPayload]);
    }
  }

  function checkQuizPayload(payload, giftPayload, correctAnswer) {
    let msgId = getMsgId(payload);
    if (saveStateMgr.isMsgRead(msgId)) return;

    if (correctAnswer) {
      saveStateMgr.markMsgAsRead('quiz', msgId);
      openQuizGift();
    } else {
      showIncorrectAnswerPopUp();
    }
    
    function openQuizGift() {
      let giftPack = [];
      for (let i = 0; i < giftPayload.giftData.length; i++) {
        let gift = [giftPayload.giftData[i].itemId, giftPayload.giftData[i].amount];
        giftPack.push(gift);
      }
      onPopUpReqested.dispatch(['gift', {
        showTitleBar: false,
        showGingy: true,
        showGingyGiftBar: false,
        autoOpen: true,
        titleTextBar: {
          titleTxt: OMT.language.getText('Congratulations!'),
          subtitleTxt: OMT.language.getText('You answered correctly!'),
          y: -200
        },
        gingyTitleOffset: {
          x: 0,
          y: -240
        },
        gingyOffset: {
          x: 40,
          y: 100
        },
        giftOffset: {
          x: 0,
          y: 20
        },
        buttonsOffset: {
          x: 0,
          y: -60
        },
        gifts: giftPack,
        monetiseType: false,
        resourceTracking: {
          itemType: 'Reward',
          itemId: 'Quiz',
        },
        shareable: false,
        incentivisedSharing: false
      // and blocks input
      // }], false, G.WindowMgr.LayerNames.BelowHeaderPanel);
      }]);
    }

    function showIncorrectAnswerPopUp() {
      onPopUpReqested.dispatch(['incorrectAnswer', {
        titleTextBar: {
          titleTxt: OMT.language.getText('Too bad!'),
          subtitleTxt: OMT.language.getText('You answered incorrectly!'),
          y: 0,
        }
      }])
    }
  }

  function checkRestoreProgressionPayload(payload, restoreProgression) {

    try {
      const levelsCompleted = restoreProgression.levelsCompleted;
      const coins = restoreProgression.coins ? restoreProgression.coins : 0;
      let restored = false;
      if (levelsCompleted !== undefined) {
        restored = G.saveState.restoreProgress(levelsCompleted, coins);
      }

      game.state.onStateChange.addOnce(() => {
        game.state.onUpdateCallback = () => {
          delete game.state.onUpdateCallback;
          if (payload.gift) { 
            setTimeout(() => {
              checkGiftPayload(payload, payload.gift);
            },250);
          }
        }
      });
      window.game.state.restart();
   
    } catch(error) {
      G.Utils.SentryLog.logError('Failed to restore progression from payload: ' + error);
    }
  }

  function checkPromoRewardPayload(payload) {
    let gift = [
      [ 'coin', 2000 ]
    ];
    // Ensure the user didn't get the gift in the past
    if (saveStateMgr.isMsgRead(payload.originGameId)) return;
    // Define reward, and track
    if (G.saveState.data.finishedTutorials.length >= 2) {
      gift = [
        [ 'coin', 500 ]
      ];
    }

    // Open popup
    console.log('new promo reward, payload.originGameId = ', payload.originGameId);
    onPopUpReqested.dispatch(['gift', {
      titleTextBar: {
        titleTxt: OMT.language.getText('Thanks for subscribing!'),
      },
      showGingy: false,
      showGingyGiftBar: false,
      autoOpen: true,
      autoOpenDelay: 1500,
      gifts: gift,
      onClaim: function(){
        G.saveState.markMsgAsRead('promoReward' , payload.originGameId);
      },
      monetiseType: false,
      resourceTracking: {
        itemType: 'Reward',
        itemId: 'CrossPromoReward',
      },
      shareable: false
    }], false, G.WindowMgr.LayerNames.Base);
  }

  function checkRequestHelpPayload(payload, requestHelpPayload) {

    if (!payload.sendParams) return; 
    let msgId = getMsgId(payload);

    if (!saveStateMgr.isMsgRead(msgId)
      && payload.sendParams.senderId !== currentPlayerId) {
      saveStateMgr.markMsgAsRead('requestHelpMsg', msgId);
      onPopUpReqested.dispatch(['requestHelpMessage', requestHelpPayload]);
    }
  }

  function checkfriendshipChestInvitePayload(payload, friendshipChestPayload, isPreloader = false) {
    if (isPreloader) { // Happens at preloader check. If not, it continues to work check. Assuming message is still valid
      if (G.firstTime) {
        G.saveState.friendshipChestDataManager.setInvitedBy(friendshipChestPayload.inviterFbId);
        OMT.messaging.sendMessage(friendshipChestPayload.inviterGbId, "friendJoined", {messageType:"friendJoined", senderUserData: currentPlayerId});
        OMT.notifications.scheduleGameTriggeredMessage(friendshipChestPayload.inviterFbId, 'FriendshipChestClaimed', 1, null, false);
        OMT.platformTracking.logEvent(OMT.platformTracking.Events.InviteFromReferral);
      }
      return;
    }

    if (!payload.sendParams) return; 
    let msgId = getMsgId(payload);

    if (!saveStateMgr.isMsgRead(msgId)
      && payload.sendParams.senderId !== currentPlayerId) {
      saveStateMgr.markMsgAsRead("friendshipChestMsg", msgId);
      if (G.firstTime) {
        OMT.social.sendFriendshipChestJoined(""+friendshipChestPayload.inviterFbId);
      }
    }
  }

  function checkfriendshipChestJoinPayload(payload, friendshipChestPayload) {

    if (!payload.sendParams) return; 
    let msgId = getMsgId(payload);

    if (!saveStateMgr.isMsgRead(msgId)
      && payload.sendParams.senderId !== currentPlayerId) {
      saveStateMgr.markMsgAsRead("friendshipChestMsg", msgId);
      
      if (OMT.feature.getFeatureFriendshipChest() && OMT.feature.getFriendshipChestAssetStatus().highPrio && G.saveState.friendshipChestDataManager.getUnclaimedCard()) {
        G.sb('pushWindow').dispatch(['friendshipChest']);
      }
    }
  }
  
  // this is very similar to the restore progress check function, but it overrides the save state in certain places
  function checkStateChangePayload(payload, stateChange) {
    try {
      const levelsCompleted = stateChange.levelsCompleted;
      const coins = stateChange.coins;
      const boosters = stateChange.boosters;
      if (levelsCompleted !== undefined) {
        G.saveState.loadStateChange(levelsCompleted, coins, boosters);
      }
      window.game.state.restart();
    } catch(error) {
      G.Utils.SentryLog.logError('Failed to load state from payload: ' + error);
    }
  }

  function checkFortuneCookiePayload(payload, fortuneCookiePayload) {
    if (!payload.sendParams) return;
    let msgId = getMsgId(payload);
    if (payload.sendParams.senderId == currentPlayerId) {
      G.sb('pushWindow').dispatch(['fortuneCookie', {
        playOpenAnim: false,
        showMessage: true,
        msg: fortuneCookiePayload.msg,
        category: fortuneCookiePayload.category,
      }]);
    }
    else if (!saveStateMgr.isMsgRead(msgId)) {
      if (G.firstTime) {
        // here we show it in the first level.
        G.showFortuneCookie = true;
      } else {
        G.sb('pushWindow').dispatch(['fortuneCookie', { playOpenAnim: true, hideNotNow: true }]);
      }
    }
    saveStateMgr.markMsgAsRead('fortuneCookieMsg', msgId);
  }

  function cleanup() {
    onPopUpReqested.removeAll();
    onOpenGate.removeAll();
  }
})();
